import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { TokenRoleDataSelector } from '../../redux/selectors/loginSelector'

function Breadcrumb({breadcrumbData}) {
  const tokenRoleData = useSelector(TokenRoleDataSelector);
  return (
    <div
      aria-label="Breadcrumb"
      role="navigation"
      className="el-breadcrumb settings-css"
      id="id-dashboard-header-breadcrumb"
      style={{paddingLeft:'0px', paddingTop:'16px'}}
    >
        {(tokenRoleData?.authority === 1 || tokenRoleData?.authority === 4) && (
        <span className="el-breadcrumb__item">
          <span role="link" className="el-breadcrumb__inner">
              <Link
              to="/companies?tabno=0&page=1"
              style={{ display: "inline-flex", alignItems: "center", cursor: "pointer" }}
            >
              <i className="icon-home"></i>
            </Link>
          </span>
          <span role="presentation" className="el-breadcrumb__separator">
            /
          </span>
        </span>)}
  
    
      {breadcrumbData?.map((item, index) => (
        <span className="el-breadcrumb__item" key={item?.index}>
          <span role="link" className="el-breadcrumb__inner">

            {item?.clickable !== false ? (
              <Link to={item.href} style={{ fontWeight: "300",cursor: "pointer", textDecoration: "underline" ,color: "#606266"}}>
                {item.label}
              </Link>
            ) : (
              <span style={{ fontWeight: "300", cursor: "default" }}>
                {item.label}
              </span>
            )}
          </span>

          {index < breadcrumbData.length - 1 && (
            <span
              role="presentation"
              className="el-breadcrumb__separator"
            >
              /
            </span>
          )}
        </span>
      ))}

   

    </div>
  
  )
}

export default Breadcrumb
